import { z } from 'zod';

import { RunSchema } from '@/types/schema';

const coerceNullToUndefined = <T,>(value: T | null): T | undefined => {
  return value === null ? undefined : value;
};

export const langSmithParamsSchema = z.object({
  ls_provider: z.string(),
  ls_model_name: z.string(),
  ls_model_type: z.union([z.literal('chat'), z.literal('text')]).optional(),
  ls_temperature: z.number().nullish().transform(coerceNullToUndefined),
  ls_max_tokens: z.number().nullish().transform(coerceNullToUndefined),
  ls_stop: z.array(z.string()).nullish().transform(coerceNullToUndefined),
});

export const parseLangSmithParamsFromRun = (
  extra: RunSchema['extra'] | null | undefined
): z.infer<typeof langSmithParamsSchema> | null => {
  const metadata = extra?.metadata;
  if (!metadata) return null;
  const result = langSmithParamsSchema.safeParse(metadata);
  if (result.success) return result.data;
  return null;
};
